module.exports = __webpack_public_path__ + "img/15-detail.796e3430.webp";